export const LENS_CHALLENGE_TAG_PREFIX = "ch0";

export const isChallengeTag = (tag: string): boolean => {
    return tag.toLowerCase().startsWith(LENS_CHALLENGE_TAG_PREFIX);
};
